import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import { ChangeEvent } from 'react';

interface Props {
  searchedTerm: string;
  placeholder: string;
  onSearchedTermChange: (searchedTerm: string) => void;
}

const SearchTextField = ({
  searchedTerm,
  placeholder,
  onSearchedTermChange,
}: Props) => {
  const classes = useStyles();

  const handleSearchTermChange = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => onSearchedTermChange(e.target.value);

  return (
    <TextField
      className={classes.root}
      value={searchedTerm}
      onChange={handleSearchTermChange}
      variant="standard"
      type="text"
      size="small"
      fullWidth
      placeholder={placeholder}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end" className={classes.searchIcon}>
            <SearchIcon />
          </InputAdornment>
        ),
        classes: { input: classes.searchInput },
      }}
    />
  );
};

export default SearchTextField;

const useStyles = makeStyles({
  root: {
    width: '300px',
    fontSize: '0.875rem',
    lineHeight: '1.5714285714',
    '& .MuiInput-underline:before': {
      borderBottom: '1px solid rgb(112, 111, 128)',
    },
  },
  searchInput: {
    color: 'rgba(255, 255, 255, 0.87)',
    borderStyle: 'none',
  },

  searchIcon: {
    color: 'rgb(112, 111, 128)',
  },
});
